// Certifications — replace the example entries with real certifications.
// Add certificate images to /public/images/certifications/ and reference them by path.
export const CERTIFICATIONS = [
  {
    name: "Certificate Name (e.g., ISO 9001:2015)",
    image: "/images/certifications/example-certificate-1.png",
  },
  {
    name: "Another Certificate / Registration",
    image: "/images/certifications/example-certificate-2.png",
  },
];
